module.exports = __webpack_public_path__ + "img/20_133.f786e9c3.png";